import { render, staticRenderFns } from "./Ruches.vue?vue&type=template&id=32faad95&"
import script from "./Ruches.vue?vue&type=script&lang=js&"
export * from "./Ruches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports